export const BetHistoryTypes = {
  SHOW_BET_HISTORY: "SHOW_BET_HISTORY",
  HIDE_BET_HISTORY: "HIDE_BET_HISTORY",
  FETCH_HISTORY_LINKS: "FETCH_HISTORY_LINKS",
  SET_HISTORY_LINKS: "SET_HISTORY_LINKS",
  FETCH_GAME_ROUND_HISTORY: "FETCH_GAME_ROUND_HISTORY",
  SET_GAME_ROUND_HISTORY: "SET_GAME_ROUND_HISTORY",
  FETCH_GAME_ROUND_HISTORY_PER_GAME: "FETCH_GAME_ROUND_HISTORY_PER_GAME",
  SET_GAME_ROUND_HISTORY_PER_GAME: "SET_GAME_ROUND_HISTORY_PER_GAME",
  FETCH_GAME_ROUNDS: "FETCH_GAME_ROUNDS",
  SET_GAME_ROUNDS: "SET_GAME_ROUNDS",
  FETCH_BET_HISTORY_URL: "FETCH_BET_HISTORY_URL",
  SET_BET_HISTORY_URL: "SET_BET_HISTORY_URL",
  FETCH_BET_HISTORY: "FETCH_BET_HISTORY",
  SET_BET_HISTORY: "SET_BET_HISTORY",
  ERROR_FETCH_BET_HISTORY: "ERROR_FETCH_BET_HISTORY",
  CLEAR_BET_HISTORY: "CLEAR_BET_HISTORY",
  FETCH_GAME_HISTORY_AVAILABLE_MONTHS: "FETCH_GAME_HISTORY_AVAILABLE_MONTHS",
  SET_GAME_HISTORY_AVAILABLE_MONTHS: "SET_GAME_HISTORY_AVAILABLE_MONTHS",
  SHOW_GAME_HISTORY_AVAILABLE_MONTHS: "SHOW_GAME_HISTORY_AVAILABLE_MONTHS",
  FETCH_GAME_ROUND_HISTORY_PER_GAME_ROUTE:
    "FETCH_GAME_ROUND_HISTORY_PER_GAME_ROUTE",
  SET_GAME_ROUND_HISTORY_PER_GAME_ROUTE:
    "SET_GAME_ROUND_HISTORY_PER_GAME_ROUTE",
  FETCH_WALLET_TRANSACTION_AVAILABLE_MONTHS:
    "FETCH_WALLET_TRANSACTION_AVAILABLE_MONTHS",
  SET_WALLET_TRANSACTION_AVAILABLE_MONTHS:
    "SET_WALLET_TRANSACTION_AVAILABLE_MONTHS",
  FETCH_WALLER_TRANSACTIONS: "FETCH_WALLER_TRANSACTIONS",
  SET_WALLER_TRANSACTIONS: "SET_WALLER_TRANSACTIONS",
  FETCH_WALLET_TRANSACTION_AVAILABLE_REFERENCE_TYPES:
    "FETCH_WALLET_TRANSACTION_AVAILABLE_REFERENCE_TYPES",
  SET_WALLET_TRANSACTION_AVAILABLE_REFERENCE_TYPES:
    "SET_WALLET_TRANSACTION_AVAILABLE_REFERENCE_TYPES",
  FETCH_HISTORY_BALANCE: "FETCH_HISTORY_BALANCE",
  SET_HISTORY_BALANCE: "SET_HISTORY_BALANCE",
  FETCH_BET_HISTORY_FILTER: "FETCH_BET_HISTORY_FILTER",
  SET_BET_HISTORY_FILTER: "SET_BET_HISTORY_FILTER",
};
